/**
 * Utility function to clear all timesheet-related cache data
 * This will force the application to regenerate all mock data including employee photos
 * 
 * Usage: Run this in the browser console:
 * ```
 * window.clearTimesheetCache()
 * ```
 */
export const clearTimesheetCache = () => {
  const keysToRemove = [
    'historicalDataInitialized',
    'auditHistoryInitialized',
    'sampleRejectionsInitialized'
  ];

  // Remove specific keys
  keysToRemove.forEach(key => {
    localStorage.removeItem(key);
  });

  // Also remove any keys that start with costCentre
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('costCentre')) {
      localStorage.removeItem(key);
    }
  });

  console.log('✅ Timesheet cache cleared! Refresh the page to regenerate data with new photos.');
  
  // Optionally reload the page
  if (window.confirm('Cache cleared! Would you like to reload the page now?')) {
    window.location.reload();
  }
};

// Make it available globally for easy access in console
if (typeof window !== 'undefined') {
  (window as any).clearTimesheetCache = clearTimesheetCache;
}
